import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getArtists } from '../../actions/filterActions';
import { HighlightedText } from '../../utils/HighlightText'

const ArtistFilterComponent = (props) => {

    const dispatch = useDispatch()

    const [artistValue, setArtistValue] = React.useState("")

    const {error, loading, artists, message} = useSelector(state => state.artists)

    React.useEffect(()=>{
        const identifer = setTimeout(()=>{
            if (artistValue){
                dispatch(getArtists(artistValue, props.filterList, 1, 0))
            } else {
                dispatch(getArtists(" ", props.filterList, 1, 0))
            }
        }, 500)  

        return () => { clearTimeout(identifer) }

    },[artistValue])



    const chooseHandler = (artist) => {
        if (props.filterList.filter(g => g[0] === artist.id && g[2] === props.componentId ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [artist.id, artist.title, props.componentId]]})
        } else {
                props.setFilterList((prevArr) => 
                prevArr.filter(item => item[0] !== artist.id)
            )
        }
        props.setLastChangedComponent(props.componentId)
        setArtistValue('')
    }


    return (
        <div className = "w-100 d-flex flex-column py-4">
            <div className = "w-100 d-flex position-relative px-3 px-md-0">
                <div className=' w-100 py-3 border-bottom border-1 border-info d-flex align-items-center'>
                    <input
                        type="text"
                        data-tooltip-id="new-tooltip"  
                        data-tooltip-content="For more search options, press the filter button on the right!"
                        className="fs-5 ps-2 w-100 border-0 text-white search-input bg-backcolor"
                        placeholder="Search Artists..."
                        onChange={(e)=>{setArtistValue(e.target.value)}}                      
                        value={artistValue}
                    />
                </div>
            </div>           
            {

                loading ? 
                <div className='w-100 text-info position-relative p-2 rounded'
                    style={{zIndex:'1000'}}
                >Loading...</div> :
                artists && artists.length ?
                <div className = "w-100 position-relative mt-3 p-2 d-flex gap-2 flex-wrap rounded" 
                    style = {{color:"#333", zIndex:1000}}
                    // onScroll={handleScroll}
                    >
                        {
                        artists.map((result) => (
                            <div
                                className=
                                {
                                    props.filterList.some(component => component[0] === result.id && component[2] === props.componentId) ?
                                    "py-1 px-4 text-backcolor text-center rounded-pill bg-info" : 
                                    "py-1 px-4 text-info text-center rounded-pill bg-blueazur"
                                }
                                role = "button"
                                style={{transition:"all 0.2s"}}
                                key = {result.id}
                            >
                                <HighlightedText 
                                    text={result.title} 
                                    highlight={artistValue} 
                                    onClick={()=>chooseHandler(result)}
                                    color = {
                                        props.filterList.some(component => component[0] === result.id && component[2] === props.componentId) ?
                                        "#010A26" :
                                        "#00C8D5"
                                    }
                                />
                            </div>
                        ))
                        }
                </div> : 
                message ? 
                <div className='w-100 text-info position-relative p-2 rounded'>
                    {message}
                </div> :""
            }
        </div>
    );
};

export default ArtistFilterComponent;